import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { TESTIMONIALS, BUSINESS } from "../data/site";
import FinalCTA from "../components/FinalCTA";

export default function Reviews() {
  return (
    <div data-testid="reviews-page">
      <section className="aqua-section pb-12">
        <div className="aqua-container max-w-3xl">
          <p className="text-eyebrow">Reviews</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 text-[#0B2F6B] leading-tight">
            Trusted by families across Southeast NC.
          </h1>
          <a
            href={BUSINESS.reviewLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-3 rounded-full border border-[#DCE7F5] bg-white px-5 py-2.5 shadow-sm hover:border-[#33BED6] transition-colors"
            data-testid="reviews-rating-badge"
          >
            <span className="font-heading font-bold text-lg text-[#0B2F6B]">5.0</span>
            <span className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#F4B740] text-[#F4B740]" />
              ))}
            </span>
            <span className="text-sm text-[#3B5878]">from 12 Google reviews</span>
          </a>
          <p className="mt-5 text-[#3B5878] text-base sm:text-lg leading-relaxed">
            Below is a selection of what our families share with us. Want to
            read more or leave one of your own? Visit our Google review page.
          </p>
          <a
            href={BUSINESS.reviewLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-leave-review-cta"
            className="btn-primary mt-7"
          >
            Leave a Google Review <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </section>

      <section className="pb-20">
        <div className="aqua-container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="card-soft p-6"
                data-testid={`review-card-${i}`}
              >
                <div className="flex mb-3">
                  {Array.from({ length: t.rating }).map((_, idx) => (
                    <Star key={idx} className="w-4 h-4 fill-[#33BED6] text-[#33BED6]" />
                  ))}
                </div>
                <p className="text-[#0B2F6B] leading-relaxed">"{t.quote}"</p>
                <div className="mt-5 pt-4 border-t border-[#DCE7F5]">
                  <p className="font-heading font-semibold text-[#0B2F6B]">{t.name}</p>
                  <p className="text-sm text-[#7C93AD]">{t.role} • {t.location}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
